import React from 'react';
import BlogCategories from '../../../../Components/Molecules/FilterOptions/BlogsFilterLayout';
import RecentBlogs from '../RecentBlogs';
import RecentBlogs2 from '../RecentBlogs2';
import Search from '../Search';
import PastEvents from '../../../Events/Components/PastEvents';

function Sidebar({
    searchInput,
    setSearchInput,
    currentPage,
    setCurrentPage,
    onFilterClick,
    filters,
    showSearch,
    showRecentBlogs,
    showCategories,
    recentBlogs,
    pastEvents,
    isLoadingEvents,
    showPastEvents,
}) {
    return (
        <div className="flex flex-col justify-start gap-y-10 lg:ml-7 xl:ml-0 2xl:ml-10 px-0 lg:px-0 xl:pr-5">
            {showSearch && (
                <Search
                    searchInput={searchInput}
                    setSearchInput={setSearchInput}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            )}
            {showCategories && (
                <BlogCategories
                    onFilterClick={onFilterClick}
                    filters={filters}
                />
            )}
            {showRecentBlogs && recentBlogs?.length >= 1 && (
                <RecentBlogs blogs={recentBlogs} />
            )}
            {showPastEvents && pastEvents?.length >= 1 && (
                <PastEvents events={pastEvents} />
            )}
        </div>
    );
}

export default Sidebar;
